module.exports = __webpack_public_path__ + "media/images/bg1-cdf5f97e1130a44fe66f55cf83b65452.jpg";